import { render, staticRenderFns } from "./NewsOverlay.vue?vue&type=template&id=3b967a58&scoped=true&"
import script from "./NewsOverlay.vue?vue&type=script&lang=js&"
export * from "./NewsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./NewsOverlay.vue?vue&type=style&index=0&id=3b967a58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b967a58",
  null
  
)

export default component.exports